import { QuickFrameError } from '@mntn-dev/errors'

export type FileUploadErrorCode = 'invalid_extension'

export class FileUploadError extends QuickFrameError<FileUploadErrorCode> {}
